module.exports = __webpack_public_path__ + "static/media/33_tn.8660746a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/33_tn.jpg
// module id = 246
// module chunks = 0